export class ContractInvestorModel {
    contractInvestorId = 0;
    contractId = 3;
    investorId = 0;
    name = "";
    file = null;
}
